namespace $.$$ {
	export class $shm_textarea_code_rows extends $.$shm_textarea_code_rows {

		// Keep the upstream memo and window calculation, bypassing only shm's
		// global eager-list policy. Textarea keeps render_visible_only=false:
		// preceding wrapped lines stay rendered and aligned with native input.
		sub_visible() {
			return this.$.$shm_list_sub_visible.call( this )
		}
	}
}
